import styled from 'styled-components';
import { Box } from '@mui/material';

export const RelatedWorkItemStyled = styled(Box)<{ isMultipleFlows: boolean }>(
  ({ theme: { palette }, isMultipleFlows }) => ({
    '&': {
      marginLeft: isMultipleFlows ? '16px' : 0,
      '& a': {
        padding: '4px 8px',
        borderRadius: '4px',
        transition: 'background-color 0.3s ease',
        color: 'inherit !important',
        justifyContent: 'space-between !important',
        alignItems: 'center !important',
        '&:hover': {
          backgroundColor: palette.action.hover,
        },
        '& > .MuiBox-root': {
          display: 'flex',
          flexDirection: 'column',
          width: 'calc(100% - 32px)',
        },
        '& button': {
          borderRadius: '50%',
          minWidth: '20px',
          padding: '2px',
          '& .MuiSvgIcon-root': {
            color: palette.text.secondary,
            width: '20px',
            height: '20px',
          },
          '&:hover': {
            backgroundColor: palette.action.hover,
            '& .MuiSvgIcon-root': {
              color: palette.primary.main,
            },
          },
        },
      },
    },
  }),
);
